import { ChangeType } from "../../../api/EventTypes"
import Label from "./Label"

export interface TextAreaProperties {
  name: string
  label: string
  value: string
  isOptional?: boolean
  readonly?: boolean
  onChange: (e: ChangeType) => void
  rows?: number
  autoFocus?: boolean
}

export const TextArea = (props: TextAreaProperties) => {
  const { name, value, autoFocus } = props
  return (
    <div className="ocs-field-container">
      <Label htmlFor={name} optional={props.isOptional} label={props.label} />
      {props.readonly ? (
        <p className="ocs-field-readonly ocs-field-readonly-textarea read-only-bg">
          {value}
        </p>
      ) : (
        <textarea
          name={name}
          className="ocs-field ocs-field-auto-height"
          onChange={props.onChange}
          rows={props.rows}
          value={value}
          id={name}
          autoFocus={autoFocus}
        />
      )}
    </div>
  )
}

TextArea.defaultProps = {
  readonly: false,
  rows: 2
}

export default TextArea
